import React from "react";
import { Skeleton } from "@shadcn-in-nx/ui/skeleton";

function ChatPageSkeleton() {
    return (
        <div className="bg-white flex flex-row h-full w-full">
            {/* Left Panel - Chat skeleton */}
            <div className="w-[30%] flex flex-col h-full border-r border-gray-200">
                {/* Header */}
                <div className="flex items-center gap-3 px-4 py-2 border-b border-gray-200 h-12">
                    <Skeleton className="w-8 h-8 rounded-lg" />
                    <Skeleton className="h-4 w-40" />
                    <div className="ml-auto flex gap-2">
                        <Skeleton className="w-8 h-8 rounded-lg" />
                        <Skeleton className="w-8 h-8 rounded-lg" />
                    </div>
                </div>

                {/* Chat messages skeleton */}
                <div className="flex-1 p-4 space-y-4 overflow-hidden">
                    <div className="flex gap-3">
                        <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
                        <div className="space-y-2 flex-1">
                            <Skeleton className="h-3 w-3/4" />
                            <Skeleton className="h-3 w-1/2" />
                        </div>
                    </div>
                    <div className="flex gap-3 justify-end">
                        <div className="space-y-2 flex-1 max-w-[70%]">
                            <Skeleton className="h-3 w-full" />
                            <Skeleton className="h-3 w-2/3" />
                        </div>
                    </div>
                    <div className="flex gap-3">
                        <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
                        <div className="space-y-2 flex-1">
                            <Skeleton className="h-3 w-5/6" />
                            <Skeleton className="h-3 w-3/5" />
                            <Skeleton className="h-3 w-2/5" />
                        </div>
                    </div>
                </div>

                {/* Input skeleton */}
                <div className="p-4 border-t border-gray-100">
                    <Skeleton className="h-12 w-full rounded-xl" />
                </div>
            </div>

            {/* Right Panel - Preview skeleton */}
            <div className="w-[70%] flex flex-col h-full">
                {/* Header bar */}
                <div className="flex items-center gap-3 px-4 py-2 border-b border-gray-200 h-12">
                    <Skeleton className="h-4 w-24" />
                    <div className="ml-auto flex gap-2">
                        <Skeleton className="w-20 h-7 rounded-md" />
                        <Skeleton className="w-20 h-7 rounded-md" />
                    </div>
                </div>

                {/* Content skeleton */}
                <div className="flex-1 p-6 space-y-6">
                    {/* Top section */}
                    <div className="flex gap-4">
                        <Skeleton className="h-32 w-1/3 rounded-xl" />
                        <Skeleton className="h-32 w-1/3 rounded-xl" />
                        <Skeleton className="h-32 w-1/3 rounded-xl" />
                    </div>
                    {/* Main area */}
                    <Skeleton className="h-64 w-full rounded-xl" />
                    {/* Bottom cards */}
                    <div className="flex gap-4">
                        <Skeleton className="h-24 w-1/2 rounded-xl" />
                        <Skeleton className="h-24 w-1/2 rounded-xl" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default React.memo(ChatPageSkeleton);
